import {type AppFromBackapi} from '@utils/fetchAppsByPackageNames';

import {useEnvContext} from '@web-landing/components/EnvContext/EnvContextProvider';

import {ArticleType} from '@strapi/types';

import {logTmrEvent} from '@web-landing/analytics/helpers/logTmrEvent';

import {emitEcommerceSelectAppEventWithCookie} from '@web-landing/analytics/emitEcommerceSelectAppEventWithCookie';
import {EVENTS} from '@web-landing/analytics/events';
import {YANDEX_METRIKA_ID} from '@web-landing/analytics/ids';

//параметры для аналитики блока "Полезное"
const compilationAnalyticsParams = {
  compilation_type: 'card',
  compilation_num: 2,
  compilation_name: 'Полезное',
  compilation_id: 'landing_app_compilation_PDkUg3',
};

//параметры для аналитики блока "Игры месяца"
const gamesAnalyticsParams = {
  compilation_type: 'grid',
  compilation_num: 3,
  compilation_name: 'Игры месяца',
  compilation_id: 'landing_app_compilation_OYwhp4',
};

const ym_log = {
  compilationClickYM: () => {
    window.ym(YANDEX_METRIKA_ID, 'reachGoal', 'compilation_click');
  },

  compilationCardClickYM: () => {
    window.ym(YANDEX_METRIKA_ID, 'reachGoal', 'compilationCard_click');
  },
};

export const useArticlesAnalytics = () => {
  const {cookieDomain} = useEnvContext();

  const compilationCardClick = () => {
    logTmrEvent(EVENTS.compilationCardClick, compilationAnalyticsParams);
    ym_log.compilationCardClickYM();
  };
  const articleCardClick = (article_name: string) => {
    logTmrEvent(EVENTS.articleClick, {
      ...compilationAnalyticsParams,
      article_name: article_name,
    });
  };

  const compilationClick = () => {
    logTmrEvent(EVENTS.compilationClick, compilationAnalyticsParams);
    ym_log.compilationClickYM();
  };

  const compilationSwipeLeftSwipe = () => {
    logTmrEvent(EVENTS.compilationSwipeLeftSwipe, compilationAnalyticsParams);
  };

  const compilationSwipeRightSwipe = () => {
    logTmrEvent(EVENTS.compilationSwipeRightSwipe, compilationAnalyticsParams);
  };
  const onAccordionClick = () => {
    logTmrEvent(EVENTS.prostoreAccordionClick);
  };
  const appSelect = (app: AppFromBackapi, appNum: number) => {
    logTmrEvent(EVENTS.appSelect, {
      app_id: app.appId,
      app_name: app.appName,
      app_num: appNum,
      compilation_id: 'landing_app_compilation_PDkUg3',
      compilation_type: 'grid',
      position: appNum,
      app_packageName: app.packageName,
    });

    emitEcommerceSelectAppEventWithCookie({
      appId: app.appId,
      packageName: app.packageName,
      listName: 'Полезное',
      position: appNum,
      cookieDomain,
    });
  };

  const gameSelect = (app: AppFromBackapi, appNum: number) => {
    logTmrEvent(EVENTS.appSelect, {
      app_id: app.appId,
      app_name: app.appName,
      app_num: appNum,
      compilation_id: 'landing_app_compilation_OYwhp4',
      compilation_type: 'grid',
      position: appNum,
      app_packageName: app.packageName,
    });

    logTmrEvent(EVENTS.omicronFromLandingToVitrina);

    emitEcommerceSelectAppEventWithCookie({
      appId: app.appId,
      packageName: app.packageName,
      listName: 'Игры месяца',
      position: appNum,
      cookieDomain,
    });
  };

  const landingRecommendedAppsView = (type: 'articles' | 'games') => {
    const params =
      type === 'articles' ? compilationAnalyticsParams : gamesAnalyticsParams;

    logTmrEvent(EVENTS.landingRecommendedAppsView, params);
  };

  const downloadAppClick = (app: AppFromBackapi) => {
    logTmrEvent(EVENTS.appDownloadClick, {
      app_name: app.appName,
      app_id: app.packageName,
    });
  };

  const featuringCardInArticleClick = (index: number) => {
    logTmrEvent(EVENTS.compilationCardClick, {
      compilation_id: 'article_compilation_ORlHa4',
      compilation_name: 'подборки приложений',
      compilation_num: index + 1,
      compilation_type: 'card',
    });
  };

  const downloadRustoreButtonClick = (index: number) => {
    logTmrEvent(EVENTS.downloadRuStoreButton, {button_num: index + 1});
  };

  const similarArticleClick = (article: ArticleType) => {
    logTmrEvent(EVENTS.relatedArticlesClick, {
      text: article.cardTitle,
    });
  };

  return {
    compilationCardClick,
    compilationClick,
    compilationSwipeLeftSwipe,
    compilationSwipeRightSwipe,
    appSelect,
    gameSelect,
    landingRecommendedAppsView,
    downloadAppClick,
    featuringCardInArticleClick,
    downloadRustoreButtonClick,
    similarArticleClick,
    onAccordionClick,
    articleCardClick,
  };
};
